import { makePatchRequest } from 'owa-ows-gateway';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { logUsage } from 'owa-analytics';
import { NotificationSettingValue, DESKTOP_SETTINGS_URL, settingName } from '../utils/Constants';
import type { ObservableMap } from 'mobx';

export function patchNotificationSettings(
    newSettings: ObservableMap<string, NotificationSettingValue>
): Promise<boolean> {
    const requestString = JSON.stringify(newSettings);
    const jsonArray = [
        {
            name: settingName,
            value: requestString,
            type: 'JSON',
            scope: getUserConfiguration()?.SessionSettings?.UserPrincipalName,
            secondaryKey: settingName,
            itemClass: 'RoamingSetting',
        },
    ];

    // header to override timestamp check done by ocs which checks if the client saving has the latest value.
    const customHeaders = {
        'x-overridetimestamp': true,
    };

    return makePatchRequest(DESKTOP_SETTINGS_URL, jsonArray, undefined, undefined, customHeaders)
        .then((response: Response) => {
            logUsage('NativeNotificationSettingsSaveSuccess');
            // due to some reason response.status is not being populated with response code so had to use this way of checking if the call was successful or not
            return response?.toString().length > 0;
        })
        .catch(err => {
            logUsage('NativeNotificationSettingsSaveFailure', {
                error: err.message,
            });
            return false;
        });
}
